'use strict';

module.exports = ['$rootScope', '$state', 'ngDroUtilsNotify', function ($rootScope, $state, ngDroUtilsNotify) {

        /*
         * Evita il loop del 403 quando l'utente non ha i permessi per andare nella index
         */
        var previousState;

        /* 
         * Evita la notifica multipla sulla stessa pagina
         * 
         * Tengo traccia degli errori notificati. Quando partono n richieste asincrone, non racchiuse in una singola promise, succede che gli errori
         * vengono notificati n volte (soprattutto se non c'è il raggruppamento nel settaggio di ngToast). In questo modo, non emetto la notifica se
         * già notificato negli ultimi lastError.validation millisecondi
         */
        var lastError = {
            notifiedErrorStates: [],
            timestamp: 0,
            validation: 1000
        };

        function isAlreadyNotified(errorCode) {
            if (new Date().getTime() - lastError.timestamp <= lastError.validation) { // check basato sul timestamp
                if (lastError.notifiedErrorStates.indexOf(errorCode) !== -1) {
                    return true;
                } else {
                    lastError.notifiedErrorStates.push(errorCode);
                }
            } else {
                lastError.notifiedErrorStates = [errorCode];
                lastError.timestamp = new Date().getTime();
            }
            return false;
        }

        var onError401 = function (event, data) {
            // NB. non si entra in questo blocco se nella chiamata http è stato settato passato {sendErrors: false},
            if (!isAlreadyNotified("401")) {
                ngDroUtilsNotify.error(null, 'jdro_common.error_401', null);
                ngDroUtilsNotify.unregisterListner();
            }
            $state.go('login');
        };

        var onError403 = function (event, data) {
            // NB. non si entra in questo blocco se nella chiamata http è stato settato passato {sendErrors: false},
            if (!isAlreadyNotified("403")) {
                ngDroUtilsNotify.error(null, 'jdro_common.error_403', null);
                ngDroUtilsNotify.unregisterListner();
            }

            //Evita il loop del 403 quando l'utente non ha i permessi per andare nella index
            if (previousState !== $state.current.name) {
                previousState = $state.current.name;
                $state.go('index');
            } else {
                $state.go('handles-403-loop');
            }
        };

        var onServerError = function (event, data) {
            // NB. non si entra in questo blocco se nella chiamata http è stato settato passato {sendErrors: false},
            //status -1 net err
        };

        this.init = function () {
            $rootScope.$on('ngDroError401', onError401);
            $rootScope.$on('ngDroError403', onError403);
            $rootScope.$on('ngDroServerError', onServerError);
        };

        // API
        return {
            init: this.init
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/error/ErrorHandler.js
// module id = 390
// module chunks = 0